(function () {
  'use strict';

  var SELECTOR = '[data-brand-partners]';

  function initCarousel(container) {
    var track = container.querySelector('[data-brand-partners-carousel]');
    if (!track || track.dataset.initialized === 'true') return;

    if (typeof Flickity === 'undefined') return;

    var autoplay = track.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(track.dataset.autoplaySpeed, 10) || 5000;

    var flickity = new Flickity(track, {
      cellSelector: '[data-carousel-cell]',
      cellAlign: 'left',
      contain: true,
      pageDots: track.dataset.pageDots !== 'false',
      prevNextButtons: track.dataset.arrows !== 'false',
      wrapAround: true,
      draggable: true,
      autoPlay: autoplay ? autoplaySpeed : false,
      pauseAutoPlayOnHover: true
    });

    track.dataset.initialized = 'true';
    track._brandPartnersFlickity = flickity;
  }

  function destroyCarousel(container) {
    var track = container.querySelector('[data-brand-partners-carousel]');
    if (track && track._brandPartnersFlickity) {
      track._brandPartnersFlickity.destroy();
      track.dataset.initialized = 'false';
      track._brandPartnersFlickity = null;
    }
  }

  function initSection(container) {
    if (!container) return;
    destroyCarousel(container);

    if (container.dataset.layout === 'carousel') {
      initCarousel(container);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector(SELECTOR);
    initSection(container);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target.querySelector(SELECTOR);
    destroyCarousel(container);
  });
})();
